var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875",
    transform: "translate(0 -0.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    transform: "translate(0 0.398)",
    fill: "none",
    stroke: "#383535",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M8,6.135a4.1,4.1,0,1,0,4.1,4.1A4.095,4.095,0,0,0,8,6.135ZM8,12.9a2.666,2.666,0,1,1,2.666-2.666A2.671,2.671,0,0,1,8,12.9Zm5.226-6.935a.957.957,0,1,1-.957-.957A.954.954,0,0,1,13.222,5.967Zm2.716.971a4.734,4.734,0,0,0-1.292-3.352,4.765,4.765,0,0,0-3.352-1.292c-1.321-.075-5.279-.075-6.6,0A4.758,4.758,0,0,0,1.343,3.582,4.75,4.75,0,0,0,.051,6.934c-.075,1.321-.075,5.279,0,6.6a4.734,4.734,0,0,0,1.292,3.352,4.771,4.771,0,0,0,3.352,1.292c1.321.075,5.279.075,6.6,0a4.734,4.734,0,0,0,3.352-1.292,4.765,4.765,0,0,0,1.292-3.352c.075-1.321.075-5.276,0-6.6Zm-1.706,8.013a2.7,2.7,0,0,1-1.521,1.521c-1.053.418-3.552.321-4.715.321s-3.666.093-4.715-.321a2.7,2.7,0,0,1-1.521-1.521c-.418-1.053-.321-3.552-.321-4.715s-.093-3.666.321-4.715A2.7,2.7,0,0,1,3.281,4C4.334,3.582,6.833,3.679,8,3.679s3.666-.093,4.715.321a2.7,2.7,0,0,1,1.521,1.521c.418,1.053.321,3.552.321,4.715S14.65,13.9,14.232,14.951Z",
    transform: "translate(12.006 9.763)",
    fill: "#afafaf"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.7aba1f62911b66a4b8f164f107639f13.svg";
export { ForwardRef as ReactComponent };